import { Button } from "@/components/elements/Button";
import { CompanyBranchExportCsvButton } from "@/features/company/components/CompanyBranchExportCsvButton";
import { CompanyBranchImportCsvButton } from "@/features/company/components/CompanyBranchImportCsvButton";
import { CompanyBranchList } from "@/features/company/components/CompanyBranchList";
import { AppRoutes } from "@/routes/config";
import { text } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const CompanyBranchPage = () => {
  const navigate = useNavigate();
  const [selectedCompanyBranchIds, setSelectedCompanyBranchIds] = useState<string[]>([]);

  return (
    <Stack gap={2} p={3}>
      <Stack flexDirection="row" justifyContent="space-between" alignItems="center">
        <Typography variant="head20Bold" color={text.primary}>
          事業所管理
        </Typography>
        <Stack direction="row" gap={3}>
          <CompanyBranchExportCsvButton selectedCompanyBranchIds={selectedCompanyBranchIds} />
          <CompanyBranchImportCsvButton />
          <Button
            variant="primary"
            size="sm"
            onClick={() => {
              navigate(AppRoutes.companyBranchCreate);
            }}
          >
            新規事業所登録
          </Button>
        </Stack>
      </Stack>

      <CompanyBranchList onSelectionChange={setSelectedCompanyBranchIds} />
    </Stack>
  );
};
